export const enPricingPlans = {
  planPrice: {
    symbol: '$',
    plusPlan: [
      {
        monthly: '6',
      },
    ],
    teamPlan: [
      {
        monthly: '18',
        annually: '15',
        memberLimit: 3,
        planType: 'cacoo.team3',
      },
      {
        monthly: '30',
        annually: '25',
        memberLimit: 5,
        planType: 'cacoo.team5',
      },
      {
        monthly: '60',
        annually: '50',
        memberLimit: 10,
        planType: 'cacoo.team10',
      },
      {
        monthly: '90',
        annually: '75',
        memberLimit: 15,
        planType: 'cacoo.team15',
      },
      {
        monthly: '120',
        annually: '100',
        memberLimit: 20,
        planType: 'cacoo.team20',
      },
      {
        monthly: '150',
        annually: '125',
        memberLimit: 25,
        planType: 'cacoo.team25',
      },
      {
        monthly: '180',
        annually: '150',
        memberLimit: 30,
        planType: 'cacoo.team30',
      },
      {
        monthly: '300',
        annually: '250',
        memberLimit: 50,
        planType: 'cacoo.team50',
      },
      {
        monthly: '450',
        annually: '375',
        memberLimit: 75,
        planType: 'cacoo.team75',
      },
      {
        monthly: '600',
        annually: '500',
        memberLimit: 100,
        planType: 'cacoo.team100',
      },
      {
        monthly: '1,200',
        annually: '1,000',
        memberLimit: 200,
        planType: 'cacoo.team200',
      },
    ],
    enterprisePlan: [
      {
        monthly: '18',
        annually: '600',
        memberLimit: 10,
      },
      {
        monthly: '30',
        annually: '1,200',
        memberLimit: 20,
      },
      {
        monthly: '60',
        annually: '1,800',
        memberLimit: 30,
      },
      {
        monthly: '90',
        annually: '3,000',
        memberLimit: 50,
      },
      {
        monthly: '120',
        annually: '4,800',
        memberLimit: 80,
      },
      {
        monthly: '150',
        annually: '6,000',
        memberLimit: 100,
      },
      {
        monthly: '180',
        annually: '9,000',
        memberLimit: 150,
      },
      {
        monthly: '300',
        annually: '12,000',
        memberLimit: 200,
      },
      {
        monthly: '300',
        annually: 'Please contact us for a quote.',
        memberLimit: '200+',
      },
    ],
  },
}

export const jaPricingPlans = {
  planPrice: {
    symbol: '¥',
    plusPlan: [
      {
        monthly: '454',
      },
    ],
    teamPlan: [
      {
        monthly: '1,800',
        annually: '1,500',
        memberLimit: 3,
        planType: 'cacoo.team3',
      },
      {
        monthly: '3,000',
        annually: '2,500',
        memberLimit: 5,
        planType: 'cacoo.team5',
      },
      {
        monthly: '6,000',
        annually: '5,000',
        memberLimit: 10,
        planType: 'cacoo.team10',
      },
      {
        monthly: '9,000',
        annually: '7,500',
        memberLimit: 15,
        planType: 'cacoo.team15',
      },
      {
        monthly: '12,000',
        annually: '10,000',
        memberLimit: 20,
        planType: 'cacoo.team20',
      },
      {
        monthly: '15,000',
        annually: '12,500',
        memberLimit: 25,
        planType: 'cacoo.team25',
      },
      {
        monthly: '18,000',
        annually: '15,000',
        memberLimit: 30,
        planType: 'cacoo.team30',
      },
      {
        monthly: '30,000',
        annually: '25,000',
        memberLimit: 50,
        planType: 'cacoo.team50',
      },
      {
        monthly: '45,000',
        annually: '37,500',
        memberLimit: 75,
        planType: 'cacoo.team75',
      },
      {
        monthly: '60,000',
        annually: '50,000',
        memberLimit: 100,
        planType: 'cacoo.team100',
      },
      {
        monthly: '120,000',
        annually: '100,000',
        memberLimit: 200,
        planType: 'cacoo.team200',
      },
    ],
    enterprisePlan: [
      {
        monthly: '1,800',
        annually: '60,000',
        memberLimit: 10,
      },
      {
        monthly: '3,000',
        annually: '120,000',
        memberLimit: 20,
      },
      {
        monthly: '6,000',
        annually: '180,000',
        memberLimit: 30,
      },
      {
        monthly: '9,000',
        annually: '300,000',
        memberLimit: 50,
      },
      {
        monthly: '12,000',
        annually: '480,000',
        memberLimit: 80,
      },
      {
        monthly: '15,000',
        annually: '600,000',
        memberLimit: 100,
      },
      {
        monthly: '18,000',
        annually: '900,000',
        memberLimit: 150,
      },
      {
        monthly: '30,000',
        annually: '1,200,000',
        memberLimit: 200,
      },
      {
        monthly: '30,000',
        annually: 'お見積もり',
        memberLimit: '200+',
      },
    ],
  },
}
